import React from 'react';
import {createRoot} from 'react-dom/client';
import './destyle.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.scss';
import 'simplebar/dist/simplebar.min.css';

import App from './routings/App';
import {BrowserRouter} from 'react-router-dom';

const roomElm = document.getElementById('root');

try {
  if (navigator.platform.indexOf('Win') !== -1) {
    roomElm.classList.add('win');
  }

  let scrollDiv = document.createElement('div');
  scrollDiv.className = 'scrollbar-measure';
  document.body.appendChild(scrollDiv);

// Get the scrollbar width
  let scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;

// Delete the div
  document.body.removeChild(scrollDiv);
  document.documentElement.style.setProperty('--scwidth', scrollbarWidth + 'px');
} catch (e) {
  console.error(e);
}

const root = createRoot(roomElm);

root.render(
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <App/>
    </BrowserRouter>,
);
